<template>

    <div v-if="pp_teamStatus_c">

        <!-- title -->
        <div class="TQ_padding_4px TQ_text_28px TQ_margin_bottom_2px TQ_bg_purple_lite ">

            <div v-if="selectedMissionId_n == null"> {{ass_strings.oneWord_missions[p_system_langCode_e]}} </div>

            <div v-else class="TQ_grid_col_1frAuto TQ_direction_rtl">
                <div class="TQ_grid_verticalCenter"> {{ass_strings.oneWord_mission[p_system_langCode_e]}} </div>
                <img class="TQ_width_28px TQ_grid_verticalCenter TQ_clickable" :src="ass_img_leftArrow_w"  @click="selectedMissionId_n = null"/>
            </div>
        </div>

        <!-- missions list -->
        <div class="TQ_height_450px TQ_bg_gray4 TQ_scrollable"
             v-show="selectedMissionId_n == null">

            <tq-missions-list
                    :p_team-status_c="pp_teamStatus_c"
                    :p_game-status_c="pp_gameStatus_c"
                    :p_missions-groups_ac="p_missionsGroups_ac"
                    :p_side-missions_ac="p_missionsRiddles_ac"
                    :p_team-status-missions_by-riddle-id_c="p_teamStatus_missions_byRiddleId_c"
                    :p_display_lang-code_e="p_display_langCode_e"

                    :p_support_mission-groups-level_b="p_qb_metadata_c.qbm_listMissions_supportMissionsGroupsLevels_b"
                    :p_support_mission-groups_b="p_qb_metadata_c.qbm_listMissions_supportMissionsGroups_b"
                    :p_support-points_b="p_qb_metadata_c.qbm_missions_supportMissionsPoints_b"

                    :pe_click-mission_f="m_clickMission_f"/>
        </div>

        <!-- missions item-->
        <div v-if="co_getMissionRiddle_c"
             class="TQ_bg_white TQ_height_450px TQ_scrollable">

            <tq-riddle-data_war-room
                    class="TQ_padding_8px"
                    :p_name_s="selectedMissionId_n + ''"
                    :p_qb_display-lang-code_e="p_display_langCode_e"

                    :p_qb_riddle_c="co_getMissionRiddle_c"
                    :p_riddle-status_c="p_teamStatus_missions_byRiddleId_c[selectedMissionId_n]"
                    :p_qb_metadata_c="p_qb_metadata_c"

                    :p_clues-left_n="0"
                    :p_skips-left_n="0"

                    :p_display-riddle-image_b="true"

                    :pe_update-lock-status_f="(lockIndex_n, lock_c, lockStatus_e, cb_f) => {pe_update_missionRiddle_LockStatus_f(selectedMissionId_n, lockIndex_n, lock_c, lockStatus_e, cb_f)}"

            />
        </div>

    </div>

</template>

<script>

    import DisplayFile from "../../../../components/mediaComponenets/TqDisplayFile";
    import LoaderButton from "../../../../components/basic2/TqLoaderButton";
    import OnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import TqMissionsList from "../../../../components/complex/TqMissionsList";
    import TqCard from "../../../../components/basic/TqCard";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {ass_img_arrow_left_w} from "../../../../assets/scripts/Ass_Files";
    import TqRiddleData_warRoom from "../../../../components/complex/TqRiddleData_WarRoom";
    import {validator_arrayClass_fb, validator_objClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        FB_QuestBody_Metadata,
        FB_QuestBody_MissionsGroup,
        FB_QuestBody_Riddle, FB_RiddleStatus
    } from "../../../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "c_Creator_Events_Item_WarRoom_SideMissions",
        components: {
            TqRiddleData_warRoom,
            TqCard,
            TqMissionsList,
            OnTopContainer,
            LoaderButton,
            DisplayFile},
        props:{
            pp_teamStatus_c : {},
            pp_gameStatus_c : {},

            p_qb_metadata_c:{
                type: FB_QuestBody_Metadata,
                require: true,
            },
            p_missionsRiddles_ac : {
                type: Array,
                require: true,
                validator(obj){
                    return validator_arrayClass_fb(obj, FB_QuestBody_Riddle)
                }
            },
            p_missionsGroups_ac : {
                type: Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                }
            },

            p_teamStatus_missions_byRiddleId_c:{
                type: Object,
                require:true,
                validator(arr){
                    return validator_objClass_fb(arr, FB_RiddleStatus)
                }
            },
            pe_update_missionRiddle_LockStatus_f:{
                type: Function,
                require: true
            },
            p_display_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
        },

        data(){
            return {
                selectedMissionId_n: null,

                ass_strings : ass_strings,
                ass_img_leftArrow_w: ass_img_arrow_left_w,
            }
        },
        methods:{
            m_clickMission_f(missionId_n){

                this.selectedMissionId_n = missionId_n
            }

        },
        computed:{
            co_getMissionRiddle_c(){

                let ans;
                this.p_missionsRiddles_ac.forEach(riddle => {
                    if(riddle.qbr_riddleId_n === this.selectedMissionId_n)
                        ans = riddle
                })


                return ans
            }
        }
    }
</script>

<style scoped lang="scss">


</style>
